// istanbul ignore next
const isObject = (obj) => {
    if (typeof obj === 'object' && obj !== null) {
        if (typeof Object.getPrototypeOf === 'function') {
            const prototype = Object.getPrototypeOf(obj);
            return prototype === Object.prototype || prototype === null;
        }
        return Object.prototype.toString.call(obj) === '[object Object]';
    }
    return false;
};
export const mergeObjects = (...objects) => objects === null || objects === void 0 ? void 0 : objects.reduce((result, current) => {
    var _a, _b;
    result && current && ((_b = (_a = Object.keys(current)) === null || _a === void 0 ? void 0 : _a.forEach) === null || _b === void 0 ? void 0 : _b.call(_a, (key) => {
        var _a, _b;
        if (key && Array.isArray(result === null || result === void 0 ? void 0 : result[key]) && Array.isArray(current === null || current === void 0 ? void 0 : current[key])) {
            result[key] = Array.from(new Set((_b = (_a = result === null || result === void 0 ? void 0 : result[key]) === null || _a === void 0 ? void 0 : _a.concat) === null || _b === void 0 ? void 0 : _b.call(_a, current[key])));
        }
        else if (key && isObject(result === null || result === void 0 ? void 0 : result[key]) && isObject(current === null || current === void 0 ? void 0 : current[key])) {
            result[key] = mergeObjects(result === null || result === void 0 ? void 0 : result[key], current === null || current === void 0 ? void 0 : current[key]);
        }
        else {
            result[key] = current === null || current === void 0 ? void 0 : current[key];
        }
    }));
    return result;
}, {});
export const compareObject = (original, compare) => {
    return original !== null &&
        compare !== null &&
        typeof original === 'object' &&
        Object.keys(original).length > 0
        ? Object.keys(original).length === Object.keys(compare).length &&
            Object.keys(original).every((p) => p && compare && compareObject(original[p], compare[p]))
        : original === compare;
};
//# sourceMappingURL=merge-utils.js.map